import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface ParagraphDisplayFieldProps {
  field: FormField;
}

export function ParagraphDisplayField({ field }: ParagraphDisplayFieldProps) {
  const config = field.config;
  
  return (
    <p
      className={cn("text-sm leading-relaxed font-light", config.cssClass)}
      style={{ color: 'var(--ef-textSecondary, #64748B)' }}
    >
      {config.label}
    </p>
  );
}
